var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"auto","height":"400px","background-color":"#efefef"},attrs:{"id":_vm.type + '-echarts'}})}
var staticRenderFns = []

export { render, staticRenderFns }